'use client'

import { GoogleTagManager } from '@next/third-parties/google'
import Script from 'next/script';
import { useEffect, useState } from 'react';

import { GTM_GLOBAL } from 'enums/gtm';

declare let gtag: any;

const enableAnalytics = process.env.NEXT_PUBLIC_ANALYTICS === 'true' ? true : false;

const headScripts = {
  googleSiteVerification: (
    <meta
      name="google-site-verification"
      content="19nDqMsggDPQNfjLbk1RTqyxAHeiGN9DkODy5al6vQY"
    />
  ),
  consentManagerCMP: (onCmpError?: () => void) => (
    /* eslint-disable */
    <Script
      type="text/javascript"
      data-cmp-ab="1"
      src="https://cdn.consentmanager.net/delivery/autoblocking/a248964f3beb.js"
      data-cmp-host="b.delivery.consentmanager.net"
      data-cmp-cdn="cdn.consentmanager.net"
      data-cmp-codesrc="1"
      onError={onCmpError}
    />
    /* eslint-enable */
  ),
  defaultConfig: () => {
    return <script
      dangerouslySetInnerHTML={{
        __html: `
        window.dataLayer = window.dataLayer || [];
        window.__functionalConsentGranted = false;

        (function(dl) {
          function check(entry) {
            if (!window.__functionalConsentGranted
                && entry && entry.event === 'cmpEvent'
                && entry.userChoiceType
                && /useraction|loaded|automatic/.test(entry.userChoiceType)
                && entry.cmpConsentVendors
                && /(^|,)s26(,|$)/.test(entry.cmpConsentVendors)) {
              window.__functionalConsentGranted = true;
              window.dispatchEvent(new CustomEvent('gtm-analytics-consent-granted'));
            }
          }
          var wrappedPush;
          Object.defineProperty(dl, 'push', {
            configurable: true,
            enumerable: false,
            get: function() { return wrappedPush; },
            set: function(fn) {
              wrappedPush = function() {
                for (var i = 0; i < arguments.length; i++) check(arguments[i]);
                return fn.apply(dl, arguments);
              };
            }
          });
          dl.push = Array.prototype.push;
          for (var i = 0; i < dl.length; i++) check(dl[i]);
        })(window.dataLayer);

        function gtag(){ window.dataLayer.push(arguments); }

        gtag('consent', 'default', {
          'ad_storage': 'denied',
          'ad_user_data': 'denied',
          'ad_personalization': 'denied',
          'analytics_storage': 'denied'
        });
        gtag('js', new Date());
      `}
      } />
  },
  googleTagManager: (
    <GoogleTagManager gtmId={GTM_GLOBAL} />
  ),
  googleTagManagerNoScript: (
    <noscript>
      <iframe
        style={{ display: 'none', visibility: 'hidden' }}
        src="https://www.googletagmanager.com/ns.html?id=GTM-KXXMPR"
        height="0"
        width="0"
      ></iframe>
    </noscript>
  ),
};

const DefaultHeadScripts = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    if (window) {
      setIsLoaded(true);
    }
  }, [typeof window]);

  return <>
    {headScripts.defaultConfig()}
    {enableAnalytics && headScripts.googleTagManager}
    {enableAnalytics && headScripts.googleTagManagerNoScript}
    {headScripts.googleSiteVerification}
    {isLoaded && headScripts.consentManagerCMP(() => {
      // CMP blocked/failed — treat as "decline" (functional analytics only, deny ads)
      gtag('consent', 'update', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'granted',
      });
      // Synthetic cmpEvent so GTM triggers that depend on s26 vendor consent still fire
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'cmpEvent',
        cmpConsentVendors: 's26',
        userChoiceType: 'automatic',
      });
    })}
  </>
};

export { headScripts, DefaultHeadScripts };

